import React from "react";
import { Button } from "@/components/ui/button";
import { Rows3 } from "lucide-react";

// Compact / Comfortable row-density switch. Pair with the useDensity() hook.
export function DensityToggle({ compact, onToggle, testid = "grid-density-toggle" }) {
  return (
    <Button
      size="sm"
      variant="outline"
      onClick={onToggle}
      data-testid={testid}
      title={compact ? "Switch to comfortable rows" : "Switch to compact rows"}
    >
      <Rows3 className="w-4 h-4 mr-1.5" /> {compact ? "Compact" : "Comfortable"}
    </Button>
  );
}

export default DensityToggle;
